import * as actionTypes from "./actionTypes";

const initialState = {
  data: null,
  functions: [],
  typeList: [],
  replaceCheck: {},
  templateListsVars: {},
  isLoading: false,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.GET:
      return { ...state, isLoading: true };
    case actionTypes.GET_FULFILLED:
      return {
        ...state,
        isLoading: false,
        data: action.payload.data,
        functions: action.payload.functions,
        typeList: action.payload.typeList,
        replaceCheck: action.payload.replaceCheck,
        templateListsVars: action.payload.templateListsVars,
      };
    case actionTypes.GET_REJECTED:
      return { ...state, isLoading: false };

    case actionTypes.DELETE:
      return { ...state, isLoading: true };
    case actionTypes.DELETE_FULFILLED:
      return { ...state, isLoading: false, data: action.payload.data };
    case actionTypes.DELETE_REJECTED:
      return { ...state, isLoading: false };

    case actionTypes.CREATE:
      return { ...state, isLoading: true };
    case actionTypes.CREATE_FULFILLED:
      return { ...state, isLoading: false, data: action.payload.data };
    case actionTypes.CREATE_REJECTED:
      return { ...state, isLoading: false };

    case actionTypes.MODIFY:
      return { ...state, isLoading: true };
    case actionTypes.MODIFY_FULFILLED:
      return { ...state, isLoading: false, data: action.payload.data };
    case actionTypes.MODIFY_REJECTED:
      return { ...state, isLoading: false };

    case actionTypes.PREVIEW:
      return { ...state, isLoading: true };
    case actionTypes.PREVIEW_FULFILLED:
      return { ...state, isLoading: false };
    case actionTypes.PREVIEW_REJECTED:
      return { ...state, isLoading: false };

    case actionTypes.UPLOAD_DOCUMENT:
      return { ...state, isLoading: true };
    case actionTypes.UPLOAD_DOCUMENT_FULFILLED:
      return { ...state, isLoading: false, data: action.payload.data };
    case actionTypes.UPLOAD_DOCUMENT_REJECTED:
      return { ...state, isLoading: false };

    case actionTypes.DOWNLOAD_DOCUMENT:
      return { ...state, isLoading: true };
    case actionTypes.DOWNLOAD_DOCUMENT_FULFILLED:
      return { ...state, isLoading: false };
    case actionTypes.DOWNLOAD_DOCUMENT_REJECTED:
      return { ...state, isLoading: false };

    case actionTypes.RESET_STATE:
      return initialState;
    default:
      return state;
  }
}
